// test384
(384 && 0);
